{
    "customer_detail__no_tasks": "Hier gibt es noch keine Aufgaben",
    "customer_detail__no_tasks_description": "Nutze Aufgaben, um Dinge zu delegieren oder dir eine Erinnerung zu stellen",
    "customer_detail__add_task": "Neue Aufgabe erstellen",
    "customer_detail__no_open_tasks": "Hier gibt es noch keine Aufgaben",
    "customer_detail__no_open_tasks_description": "Nutze Aufgaben, um Dinge zu delegieren oder dir eine Erinnerung zu stellen",
    "customer_detail__no_completed_tasks": "Hier gibt es noch keine Aufgaben",
    "customer_detail__no_completed_tasks_description": "Zurzeit gibt es für diesen Kunden keine abgeschlossenen Aufgaben",
    "customer_detail__no_notes": "Keine Interaktionen",
    "customer_detail__no_notes_description": "Nutze Interaktionen, um Informationen zu diesem Kunden für alle einsehbar festzuhalten",
    "customer_detail__add_note": "Interaktion festhalten",
    "status_change__status_active": "Aktiv",
    "status_change__status_inactive": "Inaktiv",
    "status_change__marked_inactive": "<strong>Als dauerhaft inaktiv markiert</strong> von {{user}}",
    "status_change__reactivated": "<strong>Als aktiv markiert</strong> von {{user}}",
    "log__status_inactive": "Als dauerhaft inaktiv markiert",
    "log__status_active": "Als aktiv markiert",
    "log__insight_interested": "{{insightType}} „{{entity}}“ als relevant markiert",
    "log__insight_no_need": "{{insightType}} „{{entity}}“ als kein Bedarf markiert",
    "log__insight_buys_elsewhere": "{{insightType}} „{{entity}}“ als kauft woanders markiert",
    "log__insight_not_relevant": "{{insightType}} „{{entity}}“ als nicht relevant markiert",
    "log__insight_value": "Umsatzpotenzial {{value}}",
    "search_placeholder__customer": "Suche nach Artikel, Auftrag, Angebot …",
    "search_placeholder__global": "Suche nach Kunde, Notiz, Aufgabe",
    "filter__title": "Filter",
    "filter__add": "Filter",
    "filter__apply": "Anwenden",
    "filter__clear_all": "Alle entfernen",
    "filter__close": "Schließen",
    "filter__back": "Zurück",
    "filter__remove": "Filter {{filter}} entfernen",
    "filter__category_type": "Typ",
    "search__clear": "Suche löschen",
    "presets__label": "Schnellfilter",
    "day__no_due_date": "Ohne Fälligkeit",
    "feed__empty": "Keine Aktivitäten",
    "feed__pinned": "Angeheftet",
    "card__positions_load_error": "Positionen konnten nicht geladen werden",
    "card__open": "{{name}} öffnen",
    "card__attachments_one": "{{count}} Anhang",
    "card__attachments_other": "{{count}} Anhänge",
    "card__quote_title": "Angebot: #{{id}}",
    "card__order_title": "Auftrag: #{{id}}"
}
